import { render, staticRenderFns } from "./SectionLevelStatistics.vue?vue&type=template&id=21f58bee&scoped=true&"
import script from "./SectionLevelStatistics.vue?vue&type=script&lang=js&"
export * from "./SectionLevelStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f58bee",
  null
  
)

export default component.exports